// Charge la base commune
import './common.js'

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  if ($('.go').length) {
    const target = $('.go')
    $('html').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 40 }, { duration: 300, easing: 'linear' }, function () {
      $('html').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 40 }, { duration: 300, easing: 'linear' })
    })
  }

  // formulaire de contact
  const $c1 = $('form[name="cForm"]')
  $c1.waypoint(function () {
    getCForm($c1)
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion de la FAQ
  $('.faq-section').waypoint(function () {
    import(/* webpackChunkName: "faqSection" */ './scss/components/faqSection.scss').then(() => {
      Waypoint.refreshAll()
    })
    this.destroy()
  }, {
    offset: '100%'
  })
})
